<section class="bg-gradient-to-b from-gray-50 to-white py-12 md:py-20">
  <div
    class="bg-white shadow-strong rounded-3xl p-8 md:p-16 md:mx-10 lg:mx-20 mt-5 md:mt-10 overflow-hidden relative"
  >
    <!-- Decorative elements -->
    <div
      class="absolute top-0 right-0 w-96 h-96 bg-secondary/5 rounded-full blur-3xl -z-0"
    ></div>
    <div
      class="absolute bottom-0 left-0 w-64 h-64 bg-primary/5 rounded-full blur-3xl -z-0"
    ></div>

    <div class="relative z-10">
      <div class="inline-block mb-8">
        <h1
          class="text-3xl md:text-5xl font-bold text-primary mb-2 animate-fadeInUp"
        >
          Políticas de contratación de suscripción
        </h1>
        <div
          class="h-0.5 bg-gradient-to-r from-primary to-secondary rounded-full"
        ></div>
      </div>
      <div
        class="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-6 animate-fadeInUp"
        style="animation-delay: 0.2s"
      >
        <p class="text-lg">
          Usted solo debe suscribirse a alguno de nuestros servicios
          <span class="text-primary font-bold">con su tarjeta de crédito</span>.
          <br />Del resto nos encargamos nosotros: la entrega, instalación,
          mantenimiento del equipo y recambio de los filtros. <br /><br />
          La duración del contrato es
          <span class="text-primary font-bold"
            >anual, con opción de pagos mensuales o anuales</span
          >. Se renovará
          <span class="text-primary font-bold">automáticamente</span> por
          periodos iguales y comenzará a regir a partir de la fecha de
          instalación. <br /><br />
          En el pago mensual o anual se incluye
          <span class="text-primary font-bold"
            >el equipo en comodato, el servicio de mantenimiento y la reposición
            de filtros cada 12 meses</span
          >, además de la atención técnica ante cualquier eventualidad. Todo es
          coordinado desde nuestras instalaciones y realizado por nuestros
          técnicos especializados. <br /><br />

          Los pagos mensuales se procesan automáticamente durante los
          <span class="text-primary font-bold">primeros días de cada mes</span>
          utilizando la tarjeta de crédito registrada a través de
          <span class="text-primary font-bold">Mercado Pago</span>.<br />

          En caso de que el pago sea rechazado, el usuario tiene plazo
          <span class="text-primary font-bold">hasta el día 15</span> del mes en
          curso para regularizar el estado de su cuenta.<br />

          Tenga en cuenta que, si se produce una mora en el pago, se aplicará
          automáticamente un
          <span class="text-primary font-bold">recargo del 30%</span> sobre el
          importe del abono mensual correspondiente. <br />
          Adicionalmente, la empresa se reserva el derecho de solicitar la
          <span class="text-primary font-bold">devolución del equipo</span> por
          incumplimiento de las condiciones contractuales.<br /><br />

          La
          <span class="text-primary font-bold">cancelación anticipada</span>
          antes del cumplimiento del periodo contractual sucesivo al primer año
          implicará un
          <span class="text-primary font-bold"
            >costo equivalente al 50% de los plazos restantes por cumplir</span
          >. <br />
          Esta situación será notificada al correo electrónico registrado y el
          importe correspondiente se
          <span class="text-primary font-bold">debitará automáticamente</span>
          mediante el medio de pago seleccionado por el usuario al momento de
          contratar el servicio. <br /><br />
          Se requiere la presentación de una
          <span class="text-primary font-bold"
            >fotocopia del DNI y de un servicio a nombre del titular</span
          >
          que acredite el domicilio de instalación. <br /><br />

          En caso de que la instalación no pueda realizarse por motivos
          atribuibles al usuario,
          <span class="text-primary font-bold"
            >la suscripción será cancelada</span
          >. Las suscripciones solo entraran en vigencia
          <span class="text-primary font-bold"
            >una vez realizada la instalación de nuestros equipos</span
          >.
        </p>
      </div>

      <div class="inline-block mb-8 mt-12">
        <h2 class="text-2xl md:text-4xl font-bold text-primary mb-2">
          Condiciones para la instalación de los equipos Everfull
        </h2>
        <div
          class="h-0.5 bg-gradient-to-r from-primary to-secondary rounded-full"
        ></div>
      </div>

      <div
        class="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-6"
      >
        <p class="text-lg">
          Para que nuestros técnicos puedan realizar la instalación, es
          necesario contar con
          <span class="text-primary font-bold"
            >la llave de corte de paso del agua, acceso a la red de agua potable
            a una distancia no mayor a 5 metros y a la red eléctrica 2
            metros</span
          >. <br /><br />

          El suministro de agua proveniente de la pared deberá contar con una
          <span class="text-primary font-bold">rosca hembra de 1/2''</span>
          (habitualmente utilizada en los flexibles de cocinas o lavaderos).<br />

          El <span class="text-primary font-bold">caudal máximo</span> del
          suministro
          <span class="text-primary font-bold"
            >no debe superar los 2,5 LPM</span
          >
          (litros por minuto).<br />

          La <span class="text-primary font-bold">presión máxima</span> del agua
          no debe exceder los
          <span class="text-primary font-bold">8,27 bar</span>.<br />

          <span class="text-primary font-bold"
            >No utilice agua a una temperatura superior a 42°C</span
          >, ya que esto puede dañar los filtros.<br />

          <span class="text-primary font-bold"
            >Vida útil del filtro: 5.500 litros o 1 año</span
          >
          desde el primer uso, lo que ocurra primero.<br />

          Utilice el filtro únicamente para tratar agua que cumpla con los
          estándares de potabilidad (agua de red).<br /><br />

          Se recomienda mantener el dispenser limpio en su parte exterior, no
          apoyar objetos calientes sobre el equipo y conservar una distancia
          mínima de 20 cm respecto a la pared.
          <br /><br />
          <!--  En caso de ausentarse por más de 24 horas, se aconseja
      <strong>cerrar llave de paso del dispenser</strong>. <br /><br /> -->

          Una vez finalizado el trabajo, el técnico de Everfull tomará una
          fotografía de la instalación para garantizar la correcta realización
          del servicio.
          <br /><br />
        </p>
      </div>

      <div class="inline-block mb-8 mt-12">
        <h2 class="text-2xl md:text-4xl font-bold text-primary mb-2">
          Política de Privacidad
        </h2>
        <div
          class="h-0.5 bg-gradient-to-r from-primary to-secondary rounded-full"
        ></div>
      </div>

      <div
        class="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-6"
      >
        <p class="text-lg">
          La protección de su información personal es de suma importancia para
          nosotros. A continuación, detallamos cómo utilizamos y protegemos los
          datos de nuestros clientes.
          <br /><br />
          <span class="text-primary font-bold"
            >Uso de Información Personal</span
          >
          <br /><br />
          <span class="text-primary font-bold"
            >Recopilación de Información:</span
          >
          <br /><br />
          Al registrarse o utilizar nuestros servicios, recopilamos su dirección
          de correo electrónico y otros datos de contacto necesarios.
          <br /><br />
          <span class="text-primary font-bold">Finalidad del Uso:</span>
          <br /><br />
          La información recopilada será utilizada exclusivamente para enviarle
          información relevante sobre nuestros servicios, actualizaciones,
          novedades y ofertas especiales.
          <br /><br />
          <span class="text-primary font-bold"
            >Confidencialidad y Seguridad:</span
          >
          <br /><br />
          Nos comprometemos a proteger su información personal con las medidas
          de seguridad adecuadas para evitar su pérdida, uso indebido o acceso
          no autorizado.
          <span class="text-primary font-bold"
            >Bajo ninguna circunstancia compartiremos, venderemos o alquilaremos
            su información personal a terceros sin su consentimiento
            explícito</span
          >. <br /><br />
          <span class="text-primary font-bold">Derechos del Usuario:</span>
          <br /><br />
          Usted tiene el derecho de acceder, rectificar y eliminar sus datos
          personales en cualquier momento. Puede ejercer estos derechos
          contactándonos a través del correo electrónico
          <a
            href="mailto:atencion.hogar@everfull.com.ar"
            class="text-primary hover:underline"
            >atencion.hogar@everfull.com.ar</a
          >. <br /><br />
          <span class="text-primary font-bold"
            >Cambios en la Política de Privacidad:</span
          >
          <br /><br />
          Nos reservamos el derecho de actualizar esta política de privacidad.
          Cualquier cambio será comunicado a través de nuestro sitio web o
          mediante un aviso directo a su correo electrónico.
          <br /><br />

          Nos esforzamos por garantizar la transparencia y la seguridad en el
          manejo de sus datos personales. Su confianza es nuestra prioridad.
        </p>
      </div>
    </div>
  </div>
</section>
